// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    {{#if showLabel}}
    <terceraLabel text="{{label}}" additionalClass="{{additionalClassName}}" />
    {{/if}}

    <div class="oe-selector-right">
        <terceraNumeric
            tradingNumeric="true"
            decimalPrecision="{{dp.decimalPlaces}}"
            minValue="{{dp.minimalValue}}"
            maxValue="{{dp.maximalValue}}"
            step="{{dp.increment}}"
            incrementCoefficient="{{insIncrementCoeff}}"
            value="{{dp.value}}"
            enabled="{{dp.enabled}}"
            customError="{{dp.error}}"
            Intervals="{{dp.Intervals}}"
            rightAlignedText="{{rightAlignedText}}"
            rightAlignedTextAdditionalClass="watermark"
            name="TradingNumeric"
            valueUpDownChangeProcess="{{@this.isTrailingStop() ? null : @this.valueUpDownChangeProcess}}"
        />
    </div>
</div>
`;
// Exports
export default code;